import Vue from 'vue'
/**权限指令**/
const has = Vue.directive('has', {
 inserted: function (el, binding, vnode) {



		// 获取按钮权限
		//let btnPermissions = vnode.context.$route.meta.btnPermissions;
		//console.log(Vue.prototype.$_has(btnPermissions));
		let btnPermissions = el.value || el.getAttribute('value');
	//	console.log(el.value,btnPermissions)
		if (!Vue.prototype.$_has(btnPermissions)) {
			//这个时候就是没有权限，需要删除掉按钮

		//	console.log(el,el.parentNode);
			el.parentNode.removeChild(el);
		}



 }
});


// 权限检查方法
Vue.prototype.$_has = function (value) {

	 let isExist = false;
	 let btnPermissionsStr = JSON.parse(sessionStorage.getItem("btnPermissions"));

	 // console.log( value,"....",btnPermissionsStr,"...",btnPermissionsStr.indexOf(value) > -1);
//	 console.log(btnPermissionsStr.indexOf("domain:add"));
//	console.log(btnPermissionsStr)
//	 console.log(btnPermissionsStr.indexOf(value),value)
	 if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
	  return false;
	 }
	 if (btnPermissionsStr.indexOf(value) > -1) {
	  isExist = true;
	 }
	 return isExist;
};
export {has}



// WEBPACK FOOTER //
// ./src/api/directive.js